var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[{ 'button-default--active': _vm.isActive }, 'button-default'],domProps:{"innerHTML":_vm._s(_vm.buttonText)}})}
var staticRenderFns = []

export { render, staticRenderFns }